import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reads `?event=<id>` from the URL and, after the data dependency changes,
 * scrolls the element with `id="event-<id>"` into view and flashes it.
 *
 * Usage in a list page:
 *   useScrollToEvent(events);
 *   <li id={`event-${e.id}`}> ... </li>
 */
export function useScrollToEvent(dataDep) {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const target = params.get('event');
    if (!target) return undefined;

    // Wait one frame so the DOM is painted with the freshly loaded list
    const t = setTimeout(() => {
      const el = document.getElementById(`event-${target}`);
      if (!el) return;
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.classList.add('event-flash');
      const timer = setTimeout(() => el.classList.remove('event-flash'), 2200);
      return () => clearTimeout(timer);
    }, 50);
    return () => clearTimeout(t);
  }, [location.search, dataDep]);
}
